import { lazy } from "react";

const SignupWizard = lazy(() => import("features/Auth/Wizard"));
const SignupV2 = lazy(() => import("features/Auth/v2/Signup"));

const SigninV2 = lazy(() => import("features/Auth/v2/Signin"));
const VerifyPhoneV2 = lazy(() => import("features/Auth/v2/VerifyPhone"));
const VerifyEmailV2 = lazy(() => import("features/Auth/v2/VerifyEmail"));
const CheckEmailV2 = lazy(() => import("features/Auth/v2/CheckEmail"));
const ForgotPasswordV2 = lazy(() => import("features/Auth/v2/ForgotPassword"));
const ResetPasswordV2 = lazy(() => import("features/Auth/v2/ResetPassword"));
const PasswordResetSuccessV2 = lazy(() =>
  import("features/Auth/v2/PasswordResetSuccess")
);
const PasswordResetCompleteV2 = lazy(() =>
  import("features/Auth/v2/PasswordResetComplete")
);
const WelcomeV2 = lazy(() => import("features/Auth/v2/Welcome"));
const WelcomeConnectV2 = lazy(() => import("features/Auth/v2/Welcome/Connect"));
const WelcomeQuestionsV2 = lazy(() =>
  import("features/Auth/v2/Welcome/Questions")
);
const WelcomeConnectedV2 = lazy(() =>
  import("features/Auth/v2/Welcome/Connected")
);
const InvestmentApproach = lazy(() =>
  import("features/Auth/v2/Signup/InvestmentApproach/index")
);
const IntroQuestions = lazy(() =>
  import("features/Auth/v2/Signup/SurmountRecommendations/IntroQuestions")
);
const KycQuestions = lazy(() =>
  import("features/Auth/v2/Signup/SurmountRecommendations/KycQuestions")
);
const SurmountRecommendations = lazy(() =>
  import("features/Auth/v2/Signup/SurmountRecommendations")
);
const StyleDefining = lazy(() =>
  import("features/Auth/v2/Signup/InvestmentStyle/StyleDefining")
);
const BuildPortfolio = lazy(() =>
  import("features/Auth/v2/Signup/BuildPortfolio")
);
const ChooseStrategies = lazy(() =>
  import("features/Auth/v2/Signup/BuildPortfolio/ChooseStrategies")
);
const ConnectBrokerAccount = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/ConnectBrokerAccount")
);
const GetStarted = lazy(() => import("features/Auth/v2/Signup/GetStarted"));
const ConnectedBrokerAccounts = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/ConnectedBrokerAccounts")
);
const SurmountAccountVerifyIdentity = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/SurmountAccount/VerifyIdentity")
);
const SurmountAccountCountryCitizenship = lazy(() =>
  import(
    "features/Auth/v2/Signup/SetupFunding/SurmountAccount/CountryCitizenship"
  )
);
const SurmountAccountResidentialAddress = lazy(() =>
  import(
    "features/Auth/v2/Signup/SetupFunding/SurmountAccount/ResidentialAddress"
  )
);
const SurmountAccountEmployeeStatus = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/SurmountAccount/EmployeeStatus")
);
const SurmountAccountAnnualIncome = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/SurmountAccount/AnnualIncome")
);
const SurmountAccountFundingSourse = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/SurmountAccount/FundingSourse")
);
const SurmountAccountNetWorth = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/SurmountAccount/NetWorth")
);
const CreateAccount = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/SurmountAccount/CreateAccount")
);
const ChooseFundingMethod = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/ChooseFundingMethod")
);
const DepositFunds = lazy(() =>
  import("features/Auth/v2/Signup/FundYourAccount/DepositFunds")
);
const DepositSuccess = lazy(() =>
  import("features/Auth/v2/Signup/FundYourAccount/DepositSuccessScreen")
);
const SurmountAccountAffiliation = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/SurmountAccount/Affiliation")
);
const SurmountAccountTaxW9Agreement = lazy(() =>
  import(
    "features/Auth/v2/Signup/SetupFunding/SurmountAccount/TaxW9Agreement/index"
  )
);
const SurmountAccountStatus = lazy(() =>
  import("features/Auth/v2/Signup/SetupFunding/SurmountAccount/Status")
);
const SignupContainer = lazy(() =>
  import("features/Auth/v2/Signup/Components/SignupContainer")
);
const SurmountAccountStripeSuccess = lazy(() =>
  import("features/Auth/v2/Signup/GetStarted/StripeSuccess/index")
);
const PersonalDetails = lazy(() =>
  import("features/Auth/v2/Signup/SurmountRecommendations/PersonalDetails")
);
const PhoneVerification = lazy(() =>
  import("features/Auth/v2/Signup/SurmountRecommendations/PhoneVerification")
);

export const SIGNIN_PATH = "/signin";
export const VERIFY_PHONE_PATH = "/verify-phone";
export const RESET_PASS_PATH = "/reset-password";
export const PASSWORD_RESET_SUCCESS_PATH = "/password-reset-success";
export const PASSWORD_RESET_COMPLETE_PATH = "/password-reset-complete";
export const FORGOT_PASS_PATH = "/forgot-password";
export const CHECK_EMAIL_PATH = "/check-email";
export const SIGNUP_VERIFY_EMAIL_PATH = "/verify";
export const WELCOME_PATH = "/welcome";
export const WELCOME_CONNECTED_PATH = "/welcome/connected";
export const WELCOME_CONNECT_PATH = "/welcome/connect";
export const WELCOME_QUESTIONS_PATH = "/welcome/questions";
export const SIGNUP_WIZARD_PATH = "/signup/wizard";

export const SIGNUP_PATH = "/signup";
export const SIGNUP_INVESTMENT_APPROACH = "/signup/investment-approach";
export const SIGNUP_INVESTMENT_STYLE_DEFINING = "/signup/investment-style";
export const SIGNUP_BUILD_PORTFOLIO = "/signup/build-portfolio";
export const SIGNUP_CHOOSE_STRATEGIES =
  "/signup/build-portfolio/choose-strategies";
export const SIGNUP_SURMOUNT_RECOMMENDATIONS =
  "/signup/surmount-recommendations/";
export const SIGNUP_INTRO_QUESTIONS = `${SIGNUP_SURMOUNT_RECOMMENDATIONS}intro`;
export const SIGNUP_SURMOUNT_RECOMMENDATIONS_KYC_QUESTIONS = `${SIGNUP_SURMOUNT_RECOMMENDATIONS}kyc-questions`;

export const SIGNUP_SETUP_FUNDING = "/signup/setup-funding/";
export const SIGNUP_FUND_YOUR_ACCOUNT = "/signup/fund-your-account/";
export const SIGNUP_DEPOSIT_FUNDS = `${SIGNUP_FUND_YOUR_ACCOUNT}deposit-funds/`;
export const SIGNUP_DEPOSIT_SUCCESS = `${SIGNUP_FUND_YOUR_ACCOUNT}deposit-success/`;
export const SIGNUP_GET_STARTED = "/signup/:id/get-started";
export const SIGNUP_SURMOUNT_ACCOUNT =
  SIGNUP_SETUP_FUNDING + "surmount-account/";

export const SIGNUP_CONNECT_BROKER_ACCOUNT = `${SIGNUP_SETUP_FUNDING}connect-broker-account`;
export const SIGNUP_CONNECTED_BROKER_ACCOUNT = `${SIGNUP_SETUP_FUNDING}connected-broker-accounts`;
export const SIGNUP_CREATE_SURMOUNT_ACCOUNT = `${SIGNUP_SURMOUNT_ACCOUNT}create`;
export const SIGNUP_SURMOUNT_ACCOUNT_VERIFY_IDENTITY = `${SIGNUP_SURMOUNT_ACCOUNT}verify-identity`;
export const SIGNUP_CHOOSE_FUNDING_METHOD = `${SIGNUP_SURMOUNT_RECOMMENDATIONS}choose-funding-method`;
export const SIGNUP_SURMOUNT_ACCOUNT_COUNTRY_CITIZENSHIP = `${SIGNUP_SURMOUNT_ACCOUNT}country-citizenship`;
export const SIGNUP_SURMOUNT_ACCOUNT_ADDRESS = `${SIGNUP_SURMOUNT_ACCOUNT}address`;
export const SIGNUP_SURMOUNT_ACCOUNT_EMPLOYEE_STATUS = `${SIGNUP_SURMOUNT_ACCOUNT}employee-status`;
export const SIGNUP_SURMOUNT_ACCOUNT_ANNUAL_INCOME = `${SIGNUP_SURMOUNT_ACCOUNT}annual-income`;
export const SIGNUP_SURMOUNT_ACCOUNT_FUNDING_SOURCE = `${SIGNUP_SURMOUNT_ACCOUNT}funding-source`;
export const SIGNUP_SURMOUNT_ACCOUNT_NET_WORTH = `${SIGNUP_SURMOUNT_ACCOUNT}net-worth`;
export const SIGNUP_SURMOUNT_ACCOUNT_AFFILIATION = `${SIGNUP_SURMOUNT_ACCOUNT}affiliation`;
export const SIGNUP_SURMOUNT_ACCOUNT_TAX_W9_AGREEMENT = `${SIGNUP_SURMOUNT_ACCOUNT}tax-w9-agreement`;
export const SIGNUP_SURMOUNT_ACCOUNT_STATUS = `${SIGNUP_SURMOUNT_ACCOUNT}:id/status`;
export const SIGNUP_SURMOUNT_STRIPE_SUCCESS = `${SIGNUP_SETUP_FUNDING}success`;
export const SIGNUP_SURMOUNT_ACCOUNT_PERSONAL_DETAILS = `${SIGNUP_SURMOUNT_RECOMMENDATIONS}personal-details`;
export const SIGNUP_SURMOUNT_ACCOUNT_PHONE_VERIFICATION = `${SIGNUP_SURMOUNT_RECOMMENDATIONS}phone-verification`;

export const authRoutes = [
  {
    path: SIGNUP_PATH,
    component: <SignupV2 />,
  },
  {
    path: SIGNIN_PATH,
    component: <SigninV2 />,
  },
  {
    path: VERIFY_PHONE_PATH,
    component: <VerifyPhoneV2 />,
  },
  {
    path: CHECK_EMAIL_PATH,
    component: <CheckEmailV2 />,
  },
  {
    path: FORGOT_PASS_PATH,
    component: <ForgotPasswordV2 />,
  },
  {
    path: RESET_PASS_PATH,
    component: <ResetPasswordV2 />,
  },
  {
    path: PASSWORD_RESET_SUCCESS_PATH,
    component: <PasswordResetSuccessV2 />,
  },
  {
    path: PASSWORD_RESET_COMPLETE_PATH,
    component: <PasswordResetCompleteV2 />,
  },
  {
    path: SIGNUP_VERIFY_EMAIL_PATH,
    component: <VerifyEmailV2 />,
  },
  {
    path: SIGNUP_WIZARD_PATH,
    component: <SignupWizard />,
  },
];

export const welcomePrivateRoutes = [
  {
    path: WELCOME_PATH,
    component: <WelcomeV2 />,
  },
  {
    path: WELCOME_QUESTIONS_PATH,
    component: <WelcomeQuestionsV2 />,
  },
  {
    path: WELCOME_CONNECT_PATH,
    component: <WelcomeConnectV2 />,
  },
  {
    path: WELCOME_CONNECTED_PATH,
    component: <WelcomeConnectedV2 />,
  },
];

export const signupPrivateRoutes = [
  {
    path: SIGNUP_PATH,
    component: <SignupContainer />,
    subRoute: [
      {
        path: SIGNUP_INVESTMENT_APPROACH,
        component: <InvestmentApproach />,
      },
      {
        path: SIGNUP_INVESTMENT_STYLE_DEFINING,
        component: <StyleDefining />,
      },
      {
        path: SIGNUP_BUILD_PORTFOLIO,
        component: <BuildPortfolio />,
      },
      {
        path: SIGNUP_CHOOSE_STRATEGIES,
        component: <ChooseStrategies />,
      },
      {
        path: SIGNUP_CONNECT_BROKER_ACCOUNT,
        component: <ConnectBrokerAccount />,
      },
      {
        path: SIGNUP_CONNECTED_BROKER_ACCOUNT,
        component: <ConnectedBrokerAccounts />,
      },
      {
        path: SIGNUP_CREATE_SURMOUNT_ACCOUNT,
        component: <CreateAccount />,
      },
      {
        path: SIGNUP_CHOOSE_FUNDING_METHOD,
        component: <ChooseFundingMethod />,
      },
      {
        path: SIGNUP_SURMOUNT_RECOMMENDATIONS_KYC_QUESTIONS,
        component: <KycQuestions />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_PERSONAL_DETAILS,
        component: <PersonalDetails />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_PHONE_VERIFICATION,
        component: <PhoneVerification />,
      },
      {
        path: SIGNUP_DEPOSIT_FUNDS,
        component: <DepositFunds />,
      },
      {
        path: SIGNUP_DEPOSIT_SUCCESS,
        component: <DepositSuccess />,
      },
      {
        path: SIGNUP_INTRO_QUESTIONS,
        component: <IntroQuestions />,
      },
      {
        path: SIGNUP_SURMOUNT_RECOMMENDATIONS,
        component: <SurmountRecommendations />,
      },
      {
        path: SIGNUP_GET_STARTED,
        component: <GetStarted />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_COUNTRY_CITIZENSHIP,
        component: <SurmountAccountCountryCitizenship />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_ADDRESS,
        component: <SurmountAccountResidentialAddress />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_EMPLOYEE_STATUS,
        component: <SurmountAccountEmployeeStatus />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_ANNUAL_INCOME,
        component: <SurmountAccountAnnualIncome />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_FUNDING_SOURCE,
        component: <SurmountAccountFundingSourse />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_NET_WORTH,
        component: <SurmountAccountNetWorth />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_AFFILIATION,
        component: <SurmountAccountAffiliation />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_VERIFY_IDENTITY,
        component: <SurmountAccountVerifyIdentity />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_TAX_W9_AGREEMENT,
        component: <SurmountAccountTaxW9Agreement />,
      },
      {
        path: SIGNUP_SURMOUNT_ACCOUNT_STATUS,
        component: <SurmountAccountStatus />,
      },
      {
        path: SIGNUP_SURMOUNT_STRIPE_SUCCESS,
        component: <SurmountAccountStripeSuccess />,
      },
    ],
  },
];
